import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { OfferCodeDetailsPage } from './offer-code-details.page';

const routes: Routes = [
  {
    path: '',
    component: OfferCodeDetailsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OfferCodeDetailsPageRoutingModule {}
